module.exports = __webpack_public_path__ + "img/financialAnalysis.f415477b.png";